import React from "react";
const FailurePage = () => {
  setTimeout(function () {
    window.location.replace("/");
  }, 20000);
  return (
    <div className="OverviewContainer">
      <h1>There was a problem with your payment...</h1>
      <p>you will be redirected shortly</p>
    </div>
  );
};
export default FailurePage;
